import React from 'react';
import './../App.css';
import BlueTicket from '../Components/BlueTicket';
import Search from '../Components/Search';
import Article from '../Components/Article';
import Editor from '../Components/Editor';
import SideBar from '../Components/SideBar';
import methodsOneContext from '../Contexts/MethodsOne';
import GoodsContainer from '../Components/GoodsContainer'
import PartialSite1 from '../Components/PartialSite1';
import ScrollAnimation from 'react-animate-on-scroll';


export default class App extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.history.location.pathname);
  }

  state = {
    detailList: [],
    editId: -1
  }


  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  setDetailList(data) {

    this.setState(prevState => {
      return {
        detailList: data,
        editId: -1
      }
    })

  }

  editDetail(id) {
    this.setState(prevState => {
      return {
        editId: id
      }
    })
  }

  newEvent() {
    this.setState(prevState => {
      return {
        detailList: [{ Id: 0, Description: '', Tag: '' }],
        editId: 0
      }
    })

    console.log('رسsadadsadیدم');
    console.log(this.state);
    console.log(this.state.detailList);

  }

  render() {
    let detailList = this.state.detailList;
    let editId = this.state.editId;
    return (  

      <>
        <div class="header_section">  
        <ScrollAnimation animateIn="fadeIn">
        <div class="firstpage__header">
          <div class="container"> 
            <div class="header_main">
              <h1 class="maz-header_main--title">چگونه کسب و کارمان را آنلاین کنیم؟</h1>
              <p class="maz-header_main--description"> ورود به دنیای دیجیتال نیاز به ایده ای منظم و منسجم در قالب یک مدل کسب و کار آنلاین دارد. آنلاین شدن غیر اصولی و بی برنامه کسب وکار های سنتی، مسئله پررنگ کمبود (حتی گاهی در محدودیت مالی، نبود) نیروی فنی در کسب و کار ها را مطرح می‌کند.</p>
              <p class="maz-header_main--description">معمولا نیاز های کسب و کار سنتی شما برای آنلاین شدن کاملا مشخص هستند، یک سایت، شاید یک اپلیکیشن و قطعا پلتفرم های اجتماعی…گاهی هم کسب و کاری نیاز به اتوماسیون پیشرفته و یک پلتفرم آنلاین برای مدیریت آن نیاز دارد!</p>
              <p class="maz-header_main--description">ولی مسیر دیجیتالی شدن، مسیری غیر قابل پیش‌بینی و حساس است. روند ها روز به روز تغییر می‌کنند، تکنولوژی ها آپدیت می‌شوند و خواسته کاربران تغییر شکل پیدا می‌کند.</p>
              <p class="maz-header_main--description">ما فقط کسب و کار و ایده شما را نمی‌بینیم، گاهی دوراندیشی و آرزوی شما برای سیستم‌تان بهترین چشم اندازِ کسب و کار در سال های بعدی است… ما به شما قول می‌دهیم، که همه چیز را می‌بینیم…چه نیاز های ملموس، چه نیاز های غیرقابل پیشبینی.</p>

            </div>
            <div class="header_codeLineImage">
              <img src={require('./../img/woocommerce-seo-for-higher-revenue.png')} alt="کد" />  
            </div>
          
         
          </div>
          <div class="container"> 
      
       
            <div class="maz-about-img1">
              <img src={require('./../img/ecommerce.png')} alt="کد" />  
            </div>
            <div class="header_main">
              <h1 class="maz-header_main--title">تولید اپلیکیشن حرفه ای</h1>
              <p class="maz-header_main--description">ساخت یک اپلیکیشن حرفه ای برای وب یا موبایل مراحل مختلفی دارد که در هر کدام از این مراحل ، الگو ها و تکنولوژیهای مختلفی را بر اساس نوع پروژه نرم افزاری می توان استفاده نمود که روی بقیه مراحل تولید نرم افزار تاثیرگذار می باشد و باید بر اساس تکنولوژی روز و در نظر داشتن حداقل زمان ممکن و کمترین هزینه، انتخاب و استفاده گردد.</p>
              <p class="maz-header_main--description">حاصل این مراحل نرم افزاری است که نه تنها باید نیازمندیهای پروژه را برآورده کند بلکه باید قابلیت افزودن ماژول جدید را در کمترین زمان و کمترین هزینه ممکن دارا باشد.</p>
              <p class="maz-header_main--description">این مهم در صورتی دست یافتنی است که تیم طراح و اجرای نرم افزار تجربه کافی برای پیاده سازی این تکنولوژیها را دارا باشد تا با اجرای درست مراحل تولید نرم افزار محصول خروجی حرفه ای با کاراییه قابل قبول ارائه گردد.</p>
            
            </div>
          
         
          </div>
          <div class="container"> 
          <div class="header_main">
          <h1>خدمات شرکت نرم افزاری بیت کالا</h1>
              <p class="maz-header_main--description">راهکار های ما در بیت کالا در حوزه ساخت اپلیکیشن های موبایلی برای پلتفرم های iOS و اندروید، وب سایت و اپلیکیشن های تحت وب برای سازمان ها، سامانه ها و کسب و کار های محلی تعریف می‌شوند. همچنین با توجه به دورنمای روشن کسب و کار های دیجیتال، ما امکان طراحی و پیاده سازی پلتفرم های کسب و کار را در هر سطحی با استفاده از کلان داده و مدلسازی های با کمک هوش مصنوعی داریم.</p>
              <p class="maz-header_main--description">دیدگاه طراحان سیستم در بیت کالا این است که هویت بصری باید آینه‌ی هویت برند باشد. به یکپارچگی و مفهوم فراگیر در سامانه ها اعتقاد زیادی داریم و برای رسیدن به زمینه ای مشترک با ایده‌ی مشتریانمان زمان زیادی می‌گذاریم.</p>
              <p class="maz-header_main--description">ما به اشتراک گذاری تجربیاتمان در مسیر توسعه و طراحی سیستم‌های آنلاین علاقه زیادی داریم، تردید نکنید و با ما برای دریافت مشاوره تخصصی در ارتباط باشید راه های ارتباطی در پایین همین صفحه موجود میباشد..</p>
            
            </div>
       
            <div class="header_codeLineImage maz-about-img2">
              <img src={require('./../img/web-development.png')} alt="کد" />  
            </div>
          
         
          </div>
        </div>
        </ScrollAnimation>
        </div>


      </>
    )
  }
}


